import { createAction } from '@reduxjs/toolkit';
import { normalizeError } from 'core/common/errors';
import { AppThunk } from 'core/common/store';
import { FeatureFlagsConfig, LoadFeaturesOptions } from '../entities';

export const saveFeature = createAction<{ name: string; value: string }>(
  'featureFlags/SAVE_FEATURE',
);

export const loadFeaturesPending = createAction('featureFlags/LOAD_FEATURES/pending');
export const loadFeaturesSucceed = createAction<NonNullable<FeatureFlagsConfig['features']>>(
  'featureFlags/LOAD_FEATURES/succeed',
);
export const loadFeaturesFailed = createAction('featureFlags/LOAD_FEATURES/failed');

export const updateConfig =
  createAction<NonNullable<FeatureFlagsConfig['features']>>('featureFlags/UPDATE');

export const loadFeatures =
  (options: LoadFeaturesOptions = {}): AppThunk =>
  async (dispatch, getState, context) => {
    const { featureFlags, loggingService } = context;

    try {
      dispatch(loadFeaturesPending());

      const features = await featureFlags.loadFeatures(options);

      if (!features) {
        dispatch(loadFeaturesFailed());
        return;
      }

      dispatch(loadFeaturesSucceed(features));
    } catch (e) {
      const err = normalizeError(e);
      loggingService.error(err);

      dispatch(loadFeaturesFailed());
    }
  };
